import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { IConsentCategories, IConsentState } from "../domain/profile.model";
import { ApiEndpointService } from "./api-endpoint.service";

export type ConsentChange = {
  email?: Partial<IConsentCategories>;
  whatsapp?: Partial<IConsentCategories>;
  source?: 'settings' | 'prompt';
};

export type UnsubscribeScope = 'marketing' | 'all';

/**
 * SAN-1479 (DPDP Act 2023) — consent per channel × category.
 * Callers show their own error messages: the public unsubscribe page
 * handles an invalid link itself.
 */
@Injectable({
  providedIn: "root"
})
export class ConsentService {

  constructor(private http: HttpClient) { }

  public getConsent(): Observable<IConsentState> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.CONSENT);
    return this.http.get(url).pipe(map((response: any) => response?.data));
  }

  public updateConsent(change: ConsentChange): Observable<IConsentState> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.CONSENT);
    return this.http.patch(url, change).pipe(map((response: any) => response?.data));
  }

  /** Read-only: never changes anything (safe for link scanners). */
  public describeUnsubscribeLink(token: string): Observable<{ email: string }> {
    const url = ApiEndpointService.getEndpoint(
      `${ApiEndpointService.ENDPOINT.CONSENT}/unsubscribe/${encodeURIComponent(token)}`
    );
    return this.http.get(url).pipe(map((response: any) => response?.data));
  }

  public unsubscribe(token: string, scope: UnsubscribeScope): Observable<{ email: string; scope: UnsubscribeScope }> {
    const url = ApiEndpointService.getEndpoint(
      `${ApiEndpointService.ENDPOINT.CONSENT}/unsubscribe/${encodeURIComponent(token)}`
    );
    return this.http.post(url, { scope }).pipe(map((response: any) => response?.data));
  }
}
